import React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

// HOC to inject router props into class components
function withRouter(Component) {
  return function Wrapper(props) {
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    return <Component {...props} params={params} navigate={navigate} location={location} />;
  };
}

const serviceData = {
  "web-design": {
    title: "Web Design",
    description: "Beautiful and responsive website designs.",
  },
  "seo-optimization": {
    title: "SEO Optimization",
    description: "Improve your search engine rankings.",
  },
};

class ServiceDetail extends React.Component {
  componentDidMount() {
    const { serviceId } = this.props.params;
    const service = serviceData[serviceId];

    document.title = service
      ? `${service.title} | My Website`
      : 'Service Not Found | My Website';
  }

  componentDidUpdate(prevProps) {
    const prevId = prevProps.params.serviceId;
    const currentId = this.props.params.serviceId;

    if (prevId !== currentId) {
      const service = serviceData[currentId];
      document.title = service
        ? `${service.title} | My Website`
        : 'Service Not Found | My Website';
    }
  }

  render() {
    const { serviceId } = this.props.params;
    const service = serviceData[serviceId];

    if (!service) {
      return <h2>Service not found</h2>;
    }

    return (
      <div>
        <h1>{service.title}</h1>
        <p>{service.description}</p>
      </div>
    );
  }
}

export default withRouter(ServiceDetail);
